module.exports = __webpack_public_path__ + "img/USD.36ab476e.svg";